import { createFileRoute } from "@tanstack/react-router";
import { BlogDesigner } from "@/components/design/BlogDesigner";

export const Route = createFileRoute("/dashboard/w/$workspaceId/design")({
  component: DesignRoute,
});

function DesignRoute() {
  const { workspaceId } = Route.useParams();
  return <BlogDesigner key={workspaceId} workspaceId={workspaceId} />;
}
